import { DirectoryEntry } from "@/data/directoryTypes";
import TypeBadge from "./TypeBadge";
import ConfidenceBadge from "./ConfidenceBadge";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

interface DirectoryCardProps {
  entry: DirectoryEntry;
}

const DirectoryCard = ({ entry }: DirectoryCardProps) => {
  return (
    <Link
      to={`/entry/${entry.id}`}
      className="group block rounded-lg border border-border bg-card p-5 card-base"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap mb-2">
            <TypeBadge type={entry.type} />
            <ConfidenceBadge confidence={entry.confidence} />
          </div>
          <h3 className="text-sm font-semibold text-foreground group-hover:text-primary transition-colors">
            {entry.name}
          </h3>
          <p className="text-xs text-muted-foreground mt-1.5 line-clamp-2 leading-relaxed">
            {entry.whyItMatters}
          </p>
          <div className="flex items-center gap-2 mt-3">
            <span className="text-[10px] font-mono text-muted-foreground px-1.5 py-0.5 rounded bg-secondary">
              {entry.scope}
            </span>
            {entry.cipAreas.slice(0, 2).map((area) => (
              <span key={area} className="text-[10px] font-mono text-muted-foreground px-1.5 py-0.5 rounded bg-secondary">
                {area}
              </span>
            ))}
            {entry.cipAreas.length > 2 && (
              <span className="text-[10px] font-mono text-muted-foreground">
                +{entry.cipAreas.length - 2}
              </span>
            )}
          </div>
        </div>
        <ArrowRight size={16} className="text-muted-foreground group-hover:text-primary transition-colors shrink-0 mt-1" />
      </div>
    </Link>
  );
};

export default DirectoryCard;
